export interface AssetCapabilities {
  buy: boolean;
  sell: boolean;
  swap: boolean;
  send: boolean;
  receive: boolean;
  deposit: boolean;
  withdraw: boolean;
}

export interface AssetCapabilityLike {
  asset?: string | null;
  symbol?: string | null;
  assetName?: string | null;
  capabilities?: Partial<AssetCapabilities> | null;
  canBuy?: boolean;
  canSell?: boolean;
  _v2?: {
    symbol?: string;
    capabilities?: Partial<AssetCapabilities> | null;
  };
}

export const DEFAULT_ASSET_CAPABILITIES: AssetCapabilities = {
  buy: true,
  sell: true,
  swap: true,
  send: true,
  receive: true,
  deposit: true,
  withdraw: true,
};

const ASSET_CAPABILITY_OVERRIDES: Record<string, Partial<AssetCapabilities>> = {
  ZAR8: {
    buy: false,
    sell: false,
    swap: false,
    send: true,
    receive: true,
    deposit: true,
    withdraw: true,
  },
};

export function getAssetCapabilitySymbol(
  asset?: AssetCapabilityLike | null
): string {
  return String(asset?.asset ?? asset?.symbol ?? asset?._v2?.symbol ?? "")
    .trim()
    .toUpperCase();
}

export function resolveAssetCapabilities(
  asset?: AssetCapabilityLike | null
): AssetCapabilities {
  const symbol = getAssetCapabilitySymbol(asset);
  const sourceCapabilities =
    asset?.capabilities ?? asset?._v2?.capabilities ?? {};

  const swapFallback =
    sourceCapabilities?.swap === true ? { buy: true, sell: true } : {};

  const explicitCapabilities = {
    ...(asset?.canBuy !== undefined ? { buy: asset.canBuy } : {}),
    ...(asset?.canSell !== undefined ? { sell: asset.canSell } : {}),
  };

  return {
    ...DEFAULT_ASSET_CAPABILITIES,
    ...sourceCapabilities,
    ...swapFallback,
    ...explicitCapabilities,
    ...(ASSET_CAPABILITY_OVERRIDES[symbol] ?? {}),
  };
}

export function canBuyAsset(asset?: AssetCapabilityLike | null): boolean {
  return resolveAssetCapabilities(asset).buy;
}

export function canSellAsset(asset?: AssetCapabilityLike | null): boolean {
  return resolveAssetCapabilities(asset).sell;
}
